var _defs, _path, _path2, _path3, _path4, _path5, _rect, _path6, _rect2, _rect3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterSoftner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.1,99.9c-2.2,0-4,1.8-4,4s0,0,0,0c0-2.2,1.8-3.9,4-3.9s3.9,1.8,4,3.9c0,0,0,0,0,0,0-2.2-1.8-4-4-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.1,111.8c-4.4,0-8-3.6-8-8,0,0,0,0,0,0,0,4.4,3.6,8,8,8s8-3.6,8-8,0,0,0,0c0,4.4-3.6,8-8,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298,111.9c4.4,0,8-3.6,8-8s0,0,0,0c0,4.4-3.6,8-8,8s-8-3.6-8-8c0,0,0,0,0,0,0,4.4,3.6,8,8,8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298,99.9c-2.2,0-4,1.8-4,4s0,0,0,0c0-2.2,1.8-3.9,4-3.9s3.9,1.8,4,3.9c0,0,0,0,0,0,0-2.2-1.8-4-4-4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.9,99.9c-2.2,0-4,1.8-4,4s0,0,0,0c0-2.2,1.8-3.9,4-3.9s3.9,1.8,4,3.9c0,0,0,0,0,0,0-2.2-1.8-4-4-4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 294,
    y: 127.7,
    width: 12,
    height: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.9,111.9c4.4,0,8-3.6,8-8s0,0,0,0c0,4.4-3.6,8-8,8s-8-3.6-8-8c0,0,0,0,0,0,0,4.4,3.6,8,8,8Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 294,
    y: 127.8,
    width: 12,
    height: 21.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 244.3,
    y: 476.2,
    width: 111.5,
    height: 39.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.8,123.8c2.2,0,4-1.8,4-4v-31.8c0-2.2-1.8-4-4-4h-83.6c-2.2,0-4,1.8-4,4v31.8c0,2.2,1.8,4,4,4h83.6ZM314.9,103.8c0-4.4,3.6-8,8-8s8,3.6,8,8,0,0,0,0c0,0,0,0,0,0,0,4.4-3.6,8-8,8s-8-3.6-8-8,0,0,0,0c0,0,0,0,0,0ZM290,103.8c0-4.4,3.6-8,8-8s8,3.6,8,8,0,0,0,0c0,0,0,0,0,0,0,4.4-3.6,8-8,8s-8-3.6-8-8,0,0,0,0c0,0,0,0,0,0ZM281.1,103.9c0,4.4-3.6,8-8,8s-8-3.6-8-8,0,0,0,0c0,0,0,0,0,0,0-4.4,3.6-8,8-8s8,3.6,8,8,0,0,0,0c0,0,0,0,0,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300,153.7c-30.7,0-55.7,25-55.7,55.7v261.8h111.5V209.4c0-30.7-25-55.7-55.7-55.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M309.9,150.5h0v-22.7h31.8c4.4,0,8-3.6,8-8v-31.8c0-4.4-3.6-8-8-8h-83.6c-4.4,0-8,3.6-8,8v31.8c0,4.4,3.6,8,8,8h31.8v22.7c-28.2,4.8-49.8,29.3-49.8,58.9v310.6h119.5V209.4c0-29.6-21.6-54.1-49.8-58.9ZM258.2,123.8c-2.2,0-4-1.8-4-4v-31.8c0-2.2,1.8-4,4-4h83.6c2.2,0,4,1.8,4,4v31.8c0,2.2-1.8,4-4,4h-83.6ZM294,149.7v-21.9h0c0,0,12,0,12,0h0v21.9h-12ZM355.7,516h-111.5v-39.8h111.5v39.8ZM355.7,471.2h-111.5V209.4c0-30.7,25-55.7,55.7-55.7s55.7,25,55.7,55.7v261.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.1,99.9c-2.2,0-3.9,1.8-4,3.9,0,2.2,1.8,3.9,4,3.9s3.9-1.7,4-3.9c0-2.2-1.8-3.9-4-3.9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M273.1,95.8c-4.4,0-8,3.6-8,8s0,0,0,0c0,4.4,3.6,8,8,8s8-3.6,8-8c0,0,0,0,0,0,0-4.4-3.6-8-8-8ZM277,103.9c0,2.2-1.8,3.9-4,3.9s-3.9-1.7-4-3.9c0,0,0,0,0,0,0-2.2,1.8-4,4-4s4,1.8,4,4,0,0,0,0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298,99.9c-2.2,0-3.9,1.8-4,3.9,0,2.2,1.8,3.9,4,3.9s3.9-1.7,4-3.9c0-2.2-1.8-3.9-4-3.9Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M298,111.8c4.4,0,8-3.6,8-8,0,0,0,0,0,0,0-4.4-3.6-8-8-8s-8,3.6-8,8,0,0,0,0c0,4.4,3.6,8,8,8ZM302,103.9c0,2.2-1.8,3.9-4,3.9s-3.9-1.7-4-3.9c0,0,0,0,0,0,0-2.2,1.8-4,4-4s4,1.8,4,4,0,0,0,0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.9,99.9c-2.2,0-3.9,1.8-4,3.9,0,2.2,1.8,3.9,4,3.9s3.9-1.7,4-3.9c0-2.2-1.8-3.9-4-3.9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M322.9,111.8c4.4,0,8-3.6,8-8,0,0,0,0,0,0,0-4.4-3.6-8-8-8s-8,3.6-8,8,0,0,0,0c0,4.4,3.6,8,8,8ZM326.8,103.9c0,2.2-1.8,3.9-4,3.9s-3.9-1.7-4-3.9c0,0,0,0,0,0,0-2.2,1.8-4,4-4s4,1.8,4,4,0,0,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSoftner);
export default __webpack_public_path__ + "static/media/water-softner.8a17b577e2e8fd7b5279e8314d9de339.svg";
export { ForwardRef as ReactComponent };